import { HeaderWUT } from '@wix/form-fields/viewer-wut';

export default HeaderWUT;
